/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable camelcase */

import {
  ComponentComponentsQuestion,
  Enum_Componentcomponentsquestion_Type,
} from '../types/schema.d';

export const mockPromptQuestions: ComponentComponentsQuestion[] = [
  {
    id: 'prompt-q1',
    title: 'Com base nas suas respostas, qual é o principal desafio que você enfrenta atualmente?',
    hint: 'Selecione a opção que melhor descreve sua situação',
    required: true,
    type: Enum_Componentcomponentsquestion_Type.MultipleChoiceRadio,
    answerOptions: [
      { id: 'opt-1-1', title: 'Falta de tempo para desenvolver internamente' },
      { id: 'opt-1-2', title: 'Dificuldade em encontrar profissionais qualificados' },
      { id: 'opt-1-3', title: 'Orçamento limitado para contratação' },
      { id: 'opt-1-4', title: 'Necessidade de expertise específica' },
    ],
    hash: 'prompt-desafio-principal',
  },
  {
    id: 'prompt-q2',
    title: 'Quais tecnologias são prioritárias para o seu projeto?',
    hint: 'Selecione até 3 opções',
    required: true,
    type: Enum_Componentcomponentsquestion_Type.MultipleChoiceCheckbox,
    answerOptions: [
      { id: 'opt-2-1', title: 'React/Next.js' },
      { id: 'opt-2-2', title: 'Node.js' },
      { id: 'opt-2-3', title: 'React Native' },
      { id: 'opt-2-4', title: 'Python' },
      { id: 'opt-2-5', title: 'AWS/Cloud' },
      { id: 'opt-2-6', title: 'Outro' },
    ],
    hash: 'prompt-tecnologias',
  },
  {
    id: 'prompt-q3',
    title: 'Em uma escala de 1 a 10, qual a urgência deste projeto?',
    required: true,
    type: Enum_Componentcomponentsquestion_Type.Nps,
    hash: 'prompt-urgencia',
  },
  {
    id: 'prompt-q4',
    title: 'Descreva brevemente o que você espera alcançar com este projeto',
    hint: 'Seja específico sobre seus objetivos',
    required: false,
    type: Enum_Componentcomponentsquestion_Type.OpenLongText,
    hash: 'prompt-objetivos',
  },
  {
    id: 'prompt-q5',
    title: 'Você já teve experiência com desenvolvimento terceirizado?',
    required: true,
    type: Enum_Componentcomponentsquestion_Type.Boolean,
    hash: 'prompt-experiencia-terceirizado',
  },
];
